import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class Excel {

  /**
   * @param anchos ancho por columna, en caracteres. Si no se pasa, se
   * conserva el comportamiento anterior: solo las tres primeras columnas
   * quedan dimensionadas y el resto sale con el ancho por defecto, que
   * recorta visualmente las fechas y los montos largos.
   */
  public exportAsExcelFile( json: any[], excelFileName: string, anchos?: number[] ): void {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet( json );
    worksheet['!cols'] = anchos && anchos.length
      ? anchos.map( ancho => ({ wch: ancho }) )
      : [
      {wch:15},
      {wch:21},
      {wch:18},
  ];
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: [ 'data' ] };
    const excelBuffer: any = XLSX.write( workbook, { bookType: 'xlsx', type: 'array' } );
    this.saveAsExcelFile( excelBuffer, excelFileName );
  }

  private saveAsExcelFile( buffer: any, fileName: string ): void {
    const data: Blob = new Blob( [ buffer ], { type: EXCEL_TYPE } );
    FileSaver.saveAs( data, fileName + EXCEL_EXTENSION );
  }

}